<template>
  <div id="app">
    <div style="height: 100%">
      <div v-show="isLoading" style="padding: 2rem 0; text-align: center">
        <div>
          <van-icon name="replay" />
        </div>
        <div>加载中</div>
      </div>
      <router-view v-if="!$route.meta.keepAlive && !isLoading"></router-view>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive && !isLoading"></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },
  mounted() {
    // this.getLocation();
    this.GetQueryString();
    // if (!localStorage.getItem('openid')) { // 如果缓存localStorage中没有微信openId，则需用code去后台获取
    // 	if (location.href.search('openid') != -1) {
    // 		var strs = window.location.href.split("?")
    // 		var str = strs[1].split("&")
    // 		var openid = str[0].split("=")[1]
    // 		console.log(openid)
    // 		localStorage.setItem('openid', openid)
    // 		this.$store.commit('openid', openid)
    // 		console.log(localStorage.getItem('openid'))
    // 	} else {
    // 		this.merchant()
    // 	}
    // } else {
    // 	// 别的业务逻辑
    // 	var path = this.$store.state.toPath
    // 	console.log(path)
    // 	this.$router.push({
    // 		path: path
    // 	})
    // }
    // 开启vconsole调试
    // var vconsole = new this.$vconsole();
  },
  methods: {
    GetQueryString() {
      var r = window.location.search.substr(8);
      console.log(r)
      if (r) {
        window.localStorage.setItem("openid",r);
      }
    },
    goAddress() {
      this.$router.push({
        path: "/address",
      });
    },
    store() {
      var url = window.location.href;

      window.location.href =
        "http://www.esw235.com/wechat/login/authLogin.html?redirect=" +
        url +
        "StoreImpower";
    },
    merchant() {
      var url = window.location.href;
      var path = this.$store.state.toPath;
      window.location.href =
        "http://www.esw235.com/wechat/login/authLogin.html?redirect=" +
        url +
        "#" +
        path;
    },
    agent() {
      var url = window.location.href;
      window.location.href =
        "http://www.esw235.com/wechat/login/authLogin.html?redirect=" +
        url +
        "AgentImpower";
    },
    // getCode() { // 非静默授权，第一次有弹框

    //   this.code = ''
    //   var local = window.location.href // 获取页面url
    //   var appid = 'wx65adcf0753691319'
    //   this.code = this.getUrlCode().code // 截取code
    //   if (this.code == null || this.code === '') { // 如果没有code，则去请求
    //     window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
    //   } else {
    //     // 你自己的业务逻辑
    //   }
    // },
    // getUrlCode() { // 截取url中的code方法
    //   var url = location.search
    //   this.winUrl = url
    //   var theRequest = new Object()
    //   if (url.indexOf("?") != -1) {
    //     var str = url.substr(1)
    //     var strs = str.split("&")
    //     for (var i = 0; i < strs.length; i++) {
    //       theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1])
    //     }
    //   }
    //   return theRequest

    // },
    // 获取定位信息
    getLocation() {
      var geolocation = new window.qq.maps.Geolocation(
        "V4RBZ-ACNC3-5PS3C-3PJCV-MNMGH-OVF76",
        "myapp"
      );
      console.log(geolocation.getLocation);
      geolocation.getLocation(
        (res) => {
          var coord = res.lat + "," + res.lng;
          console.log(coord);
		  this.$store.commit('location', coord)
        },
        (err) => {
          console.log("定位失败");
          var coord = "";
		  this.$store.commit('location', coord)
          console.log(coord);
        },
        {
          failTipFlag: true,
        }
      );
    },
  },
};
</script>

<style>
</style>
